export default {
  'httpRequestResult.response': 'Response',
  'httpRequestResult.noResponseDesc': 'Click Send to get a response',
};
